export enum CommentaryType {
  TASK = 'task',
  CONTACT = 'contact',
  COMMENT = 'comment',
  BASIC_DATA_BOX = 'basic-data-box',
  BOX_SECOND = 'simple-box-2',
  BOX_THIRD = 'simple-box-3',
}
